import {Component, Input, ViewChild} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import { MatMenu, MatMenuItem } from "@angular/material/menu";
import {MsalService} from "@azure/msal-angular";
import {AddProductComponent} from "../../header/add-product/add-product.component";
import { AddProgramComponent } from "src/app/program/add-program/add-program.component";
import { ProgramTypeDialogComponent } from "src/app/program/program-type-dialog/program-type-dialog.component";
import { EditEnablerProjectComponent } from "src/app/enabler/edit-enabler-project/edit-enabler-project.component";
import { Router, RouterLink } from "@angular/router";
import { EnablerItemChoiceComponent } from "src/app/enabler/enabler-item-choice/enabler-item-choice.component";

@Component({
    selector: "app-popover",
    templateUrl: "./popover.component.html",
    styleUrls: ["./popover.component.scss"],
    imports: [MatMenu, MatMenuItem, RouterLink]
})
export class PopoverComponent {
  @ViewChild("profileMenu", {static: true}) profileMenu: MatMenu;

  @Input() isAdmin: boolean;
  @Input() isWriterRightsManagement: boolean = false;
  @Input() canAddProduct: boolean = false;
  @Input() canAddDataProduct: boolean = false;
  @Input() canAddProgram: boolean = false;
  @Input() canAddEnablerProject: boolean = false;

  constructor(public authService: MsalService, private readonly dialog: MatDialog, private readonly router: Router) {}

  logout(): void {
    this.authService.logout();
  }

  openAddProductDialog(): void {
    this.dialog.open(AddProductComponent, {
      disableClose: true,
      width: "1200px",
      data: {},
    });
  }

  openAddDataProductDialog(): void {
    this.dialog.open(AddProductComponent, {
      disableClose: true,
      width: "1200px",
      data: {dataProduct: true},
    });
  }

  openAddEnablerItemDialog(): void {
    const choiceDialogRef = this.dialog.open(EnablerItemChoiceComponent, {
      disableClose: true,
      width: '700px',
      data: {},
    });

    choiceDialogRef.afterClosed().subscribe((choice) => {
      if (choice === 'project') {
        this.openAddEnablerProject();
      } else if (choice === 'product') {
        this.openAddProduct(true);
      }
    });
  }

  openAddEnablerProject() {
    this.dialog.open(EditEnablerProjectComponent, {
      disableClose: true,
      width: '800px',
      data: {},
    });
  }

  openAddProduct(enablerProduct: boolean) {
    this.dialog.open(AddProductComponent, {
      disableClose: true,
      width: '1200px',
      data: { enablerProduct: enablerProduct },
    });
  }

  openAddProgramDialog(): void {
    const typeDialogRef = this.dialog.open(ProgramTypeDialogComponent, {
      width: "400px",
      disableClose: true
    });
    typeDialogRef.afterClosed().subscribe((type: 'single' | 'multi') => {
      if (type === 'single') {
        this.dialog.open(AddProgramComponent, {
          disableClose: true,
          width: "40vw",
          data: {programType: 'single'},
        }).afterClosed().subscribe((programId) => {
          if (programId) {
            this.router.navigate(['/program', programId]);
          }
        });
      } else if (type === 'multi') {
        this.dialog.open(AddProgramComponent, {
          disableClose: true,
          width: "40vw",
          data: {programType: 'multi'},
        }).afterClosed().subscribe((programId) => {
          if (programId) {
            this.router.navigate(['/program', programId]);
          }
        });
      }
    });
  }
}
